// This file was automatically generated from appshared.imo.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.imo');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.imo.codes = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var icd10List9434 = opt_data.imo.icd10Codes;
  var icd10ListLen9434 = icd10List9434.length;
  for (var icd10Index9434 = 0; icd10Index9434 < icd10ListLen9434; icd10Index9434++) {
    var icd10Data9434 = icd10List9434[icd10Index9434];
    output.append('<span class="el8Icd10Code ', (opt_data.imo.icd10NonBillables && opt_data.imo.icd10NonBillables[icd10Index9434]) ? 'invalid' : '', '">', soy.$$escapeHtml(icd10Data9434), '</span>', (! (icd10Index9434 == icd10ListLen9434 - 1)) ? ', ' : '');
  }
  if (! opt_data.icd10Only) {
    output.append((opt_data.imo.icd9Codes && opt_data.imo.icd9Codes.length) ? ' (' : '');
    var icd9List9451 = opt_data.imo.icd9Codes;
    var icd9ListLen9451 = icd9List9451.length;
    for (var icd9Index9451 = 0; icd9Index9451 < icd9ListLen9451; icd9Index9451++) {
      var icd9Data9451 = icd9List9451[icd9Index9451];
      output.append('<span class="el8Icd9Code">', soy.$$escapeHtml(icd9Data9451), '</span>', (! (icd9Index9451 == icd9ListLen9451 - 1)) ? ', ' : '');
    }
    output.append((opt_data.imo.icd9Codes && opt_data.imo.icd9Codes.length) ? ')' : '');
  }
  if (opt_data.showHcc && opt_data.imo.hccCategories && opt_data.imo.hccCategories.length) {
    var icd10List9464 = opt_data.imo.icd10Codes;
    var icd10ListLen9464 = icd10List9464.length;
    for (var icd10Index9464 = 0; icd10Index9464 < icd10ListLen9464; icd10Index9464++) {
      var icd10Data9464 = icd10List9464[icd10Index9464];
      var catList9465 = opt_data.imo.hccCategories[icd10Index9464];
      var catListLen9465 = catList9465.length;
      for (var catIndex9465 = 0; catIndex9465 < catListLen9465; catIndex9465++) {
        var catData9465 = catList9465[catIndex9465];
        output.append((catIndex9465 == catListLen9465 - 1 && catData9465.version != '2014') ? ' <span class="el8HccCategory">' + soy.$$escapeHtml(catData9465.communityNondualAgedFactor) + '</span>' : '');
      }
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.imo.rawCodes = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var icd10List9474 = opt_data.imo.icd10Codes;
  var icd10ListLen9474 = icd10List9474.length;
  for (var icd10Index9474 = 0; icd10Index9474 < icd10ListLen9474; icd10Index9474++) {
    var icd10Data9474 = icd10List9474[icd10Index9474];
    output.append(soy.$$escapeHtml(icd10Data9474), (! (icd10Index9474 == icd10ListLen9474 - 1)) ? ', ' : '');
  }
  if (! opt_data.icd10Only) {
    output.append(' ', (opt_data.imo.icd9Codes && opt_data.imo.icd9Codes.length) ? '(' : '');
    var icd9List9486 = opt_data.imo.icd9Codes;
    var icd9ListLen9486 = icd9List9486.length;
    for (var icd9Index9486 = 0; icd9Index9486 < icd9ListLen9486; icd9Index9486++) {
      var icd9Data9486 = icd9List9486[icd9Index9486];
      output.append(soy.$$escapeHtml(icd9Data9486), (! (icd9Index9486 == icd9ListLen9486 - 1)) ? ', ' : '');
    }
    output.append((opt_data.imo.icd9Codes && opt_data.imo.icd9Codes.length) ? ')' : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.imo.imoList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var imoList9496 = opt_data.imos;
  var imoListLen9496 = imoList9496.length;
  for (var imoIndex9496 = 0; imoIndex9496 < imoListLen9496; imoIndex9496++) {
    var imoData9496 = imoList9496[imoIndex9496];
    el8.template.appshared.imo.codes({imo: imoData9496, icd10Only: opt_data.icd10Only, showHcc: opt_data.showHcc}, output);
    output.append((! (imoIndex9496 == imoListLen9496 - 1)) ? ', ' : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.imo.rawImoList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var imoList9506 = opt_data.imos;
  var imoListLen9506 = imoList9506.length;
  for (var imoIndex9506 = 0; imoIndex9506 < imoListLen9506; imoIndex9506++) {
    var imoData9506 = imoList9506[imoIndex9506];
    el8.template.appshared.imo.rawCodes({imo: imoData9506, icd10Only: opt_data.icd10Only}, output);
    output.append((! (imoIndex9506 == imoListLen9506 - 1)) ? ', ' : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.imo.mindreaderContainer = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="mr-dropdown el8ActionsMenuDialog"><div class="mr-dropdown-content el8MRContainer"><div class="mr-results-info el8MRInformTextIMO"></div><div class="mr-results padb10"></div><div class="mr-bottom-text el8MRFloatingBottomContainer">Powered by IMO&reg; Terminology. &copy;1995–2015 Intelligent Medical Objects, Inc. All Rights Reserved</div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.imo.termListHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="', (opt_data.mindreader) ? 'el8TermListHeaderMR' : 'el8TermListHeader', '"><div class="el8TermListHeaderProblem">Dx</div><div class="el8TermListHeaderIcd10">ICD-10</div><div class="el8TermListHeaderIcd9">ICD-9</div>', (! opt_data.mindreader) ? '<div class="el8TermListHeaderSnomed">SNOMED</div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.imo.termListHeaderWithHCC = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="', (opt_data.mindreader) ? 'el8TermListHeaderMR' : 'el8TermListHeader', '"><div class="el8TermListHeaderProblem">Dx</div><div class="el8TermListHeaderIcd10">ICD-10</div><div class="el8TermListHeaderIcd9">ICD-9</div><div class="el8TermListHeaderHcc">Risk V28</div>', (! opt_data.mindreader) ? '<div class="el8TermListHeaderSnomed">SNOMED</div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.imo.term = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8TermList ', (opt_data.mindreader) ? 'el8TermListMR ' + ((opt_data.isTermDisabled) ? 'el8CodeUnselectable ' : '') : '', 'term-item"', (opt_data.term.imo_code) ? ' data-imo-code="' + soy.$$escapeHtml(opt_data.term.imo_code) + '"' : '', (opt_data.term.id) ? 'data-id="' + soy.$$escapeHtml(opt_data.term.id) + '"' : '', (opt_data.isTermNonBillable) ? 'title="This term may contain ICD code(s) no longer valid for billing"' : '', '><div class="el8TermListProblem ', (opt_data.mindreader && opt_data.isTermDisabled) ? 'el8CodeDisabled' : '', '">', (! opt_data.mindreader && opt_data.isTermNonBillable) ? '<span class="el8CodeInvalidDot mr5"></span>' : '', soy.$$escapeHtml(opt_data.term.title), (opt_data.isTermNonBillable) ? '<span class="el8CodeUnbillableBadge">Non-billable code</span>' : '', '</div><div class="el8TermListIcd10">');
  if (opt_data.mindreader) {
    output.append('<span class="', (opt_data.isTermNonBillable) ? 'el8CodeDisabled' : 'el8Icd10Code el8LinkBlue', '">', soy.$$escapeHtml(opt_data.term.icd10), (opt_data.term.more_icd10) ? '+' : '', '</span>');
  } else {
    var icd10List9590 = opt_data.term.icd10s;
    var icd10ListLen9590 = icd10List9590.length;
    for (var icd10Index9590 = 0; icd10Index9590 < icd10ListLen9590; icd10Index9590++) {
      var icd10Data9590 = icd10List9590[icd10Index9590];
      output.append('<div class="el8Icd10Code ', (opt_data.term.icd10NonBillables && opt_data.term.icd10NonBillables[icd10Index9590]) ? 'invalid' : '', '" data-code="', soy.$$escapeHtml(icd10Data9590), '">', soy.$$escapeHtml(icd10Data9590), '</div>');
    }
  }
  output.append('</div><div class="el8TermListIcd9">');
  if (opt_data.mindreader) {
    output.append('<span class="el8Icd9Code el8LinkBlue">', (opt_data.term.icd9) ? soy.$$escapeHtml(opt_data.term.icd9) : '', (opt_data.term.more_icd9) ? '+' : '', '</span>');
  } else {
    var icd9List9613 = opt_data.term.icd9s;
    var icd9ListLen9613 = icd9List9613.length;
    for (var icd9Index9613 = 0; icd9Index9613 < icd9ListLen9613; icd9Index9613++) {
      var icd9Data9613 = icd9List9613[icd9Index9613];
      output.append('<div class="el8Icd9Code" data-code="', soy.$$escapeHtml(icd9Data9613), '">', soy.$$escapeHtml(icd9Data9613), '</div>');
    }
  }
  output.append('</div>');
  if (opt_data.hccScoringEnabled) {
    output.append('<div class="el8TermListHcc">');
    if (opt_data.mindreader) {
      output.append('<span class="el8HccScore">', (opt_data.term.hcc_community_factors) ? soy.$$escapeHtml(opt_data.term.hcc_community_factors) : '', '</span>');
    } else {
      output.append('<span class="el8HccScore">');
      var catList9633 = opt_data.term.hccCategories;
      var catListLen9633 = catList9633.length;
      for (var catIndex9633 = 0; catIndex9633 < catListLen9633; catIndex9633++) {
        var catData9633 = catList9633[catIndex9633];
        output.append((catData9633.version != '2014') ? '<div class="el8HccScore">' + soy.$$escapeHtml(catData9633.communityNondualAgedFactor) + '</div>' : '<div class="el8HccScore">' + soy.$$escapeHtml(catData9633.communityFactor) + '</div>');
      }
      output.append('</span>');
    }
    output.append('</div>');
  }
  output.append((! opt_data.mindreader) ? '<div class="el8TermListSnomed"><div class="el8Code" data-code="' + soy.$$escapeHtml(opt_data.term.snomed) + '">' + soy.$$escapeHtml(opt_data.term.snomed) + '</div></div><div class="el8TermListRemove el8Relative"><a class="term-remove-trigger el8RemoveButton"></a></div>' + ((opt_data.hccScoringEnabled) ? (opt_data.term.hccCategories.length) ? '<div class="relative el8Preserve padv5 el8LeftIndentLarge"><span class="el8LastAddressedDate">Last Addressed: ' + ((opt_data.term.lastAddressedDate) ? soy.$$escapeHtml(opt_data.term.lastAddressedDate) : 'Never') + '</span></div>' : '' : '') : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.imo.legacyTerm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8TermList ', (opt_data.mindreader) ? 'el8TermListMR' : '', ' term-item"', (opt_data.term.id) ? 'data-id="' + soy.$$escapeHtml(opt_data.term.id) + '"' : '', '><div class="el8TermListProblem">', soy.$$escapeHtml(opt_data.term.description), '</div><div class="el8TermListIcd10">', (opt_data.term.model_class == 'ICD10Code') ? soy.$$escapeHtml(opt_data.term.code) : '<span class="el8999">n/a</span>', '</div><div class="el8TermListIcd9">', (opt_data.term.model_class == 'ICD9Code') ? soy.$$escapeHtml(opt_data.term.code) : '<span class="el8999">n/a</span>', '</div>', (! opt_data.mindreader) ? '<div class="el8TermListSnomed"><span class="el8999">n/a</span></div><div class="el8TermListRemove el8Relative"><a class="term-remove-trigger el8RemoveButton"></a></div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.imo.sourceProblem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><span class="el8777">Source: </span><span class="el8Medium">', soy.$$escapeHtml(opt_data.description), '</span></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.imo.sourceCodes = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><span class="el8777">Coded as:</span> ');
  var snomedList9701 = opt_data.snomedCodes;
  var snomedListLen9701 = snomedList9701.length;
  for (var snomedIndex9701 = 0; snomedIndex9701 < snomedListLen9701; snomedIndex9701++) {
    var snomedData9701 = snomedList9701[snomedIndex9701];
    output.append('<span class="el8CodeSmaller">', soy.$$escapeHtml(snomedData9701), '</span> (SNOMED) ', (! (snomedIndex9701 == snomedListLen9701 - 1)) ? ', ' : '');
  }
  output.append((opt_data.snomedCodes.length && opt_data.icd9Codes.length) ? ', ' : '');
  var icd9List9712 = opt_data.icd9Codes;
  var icd9ListLen9712 = icd9List9712.length;
  for (var icd9Index9712 = 0; icd9Index9712 < icd9ListLen9712; icd9Index9712++) {
    var icd9Data9712 = icd9List9712[icd9Index9712];
    output.append('<span class="el8CodeSmaller">', soy.$$escapeHtml(icd9Data9712), '</span> (ICD-9)', (! (icd9Index9712 == icd9ListLen9712 - 1)) ? ', ' : '');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.imo.tooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8CodeTooltipWrap"><div class="el8CodeTooltipCodeLine">', soy.$$escapeHtml(opt_data.code), ' (', soy.$$escapeHtml(opt_data.codeType), ')</div>', (opt_data.description) ? '<div class="el8CodeTooltipDescription">' + soy.$$escapeHtml(opt_data.description) + '</div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};
